import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

import UserComponent from "../superAdmin/UserComponent";
import EditProfileForm from "../superAdmin/EditProfileForm";
import { handleGetUserProfile } from "../../../store/actions/userActions";

const EditManagerProfile = () => {
  const dispatch = useDispatch();
  const { user, userProfile } = useSelector((state) => state.user);
  const [isEditing, setIsEditing] = useState(false);
  useEffect(() => {
    if (user?.id && !userProfile?.data?.manager) {
      dispatch(handleGetUserProfile(user.id));
    }
  }, [user?.id, userProfile?.data?.manager]);
  const managerId = user?.id;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const userData = {
    name: userProfile?.data?.manager?.name || "",
    email: userProfile?.data?.manager?.email || "",
    city: userProfile?.data?.manager?.city || "",
    address: userProfile?.data?.manager?.address || "",
    country: userProfile?.data?.manager?.country || "",
    joinedDate: userProfile?.data?.manager?.created_at || "",
    mobile_number: userProfile?.data?.manager?.mobile_number || "",
    role: userProfile?.data?.manager?.role || "",
  };

  const userDetailsArray = [
    { label: "Name", value: userData.name },
    { label: "Email", value: userData.email },
    { label: "Address", value: userData.address },
    { label: "City", value: userData.city },
    { label: "Country", value: userData.country },
    { label: "Role", value: userData.role },
  ];

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleFormSubmit = async (updatedData) => {
    try {
      setIsUpdating(true);
      const fd = new FormData();
      Object.entries(updatedData).forEach(([key, value]) => {
        fd.append(key, value || "");
      });

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URI}/manager/profile/${managerId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${Cookies.get("auth-token")}`,
          },
          body: fd,
        }
      );

      const data = await res.json();

      if (res.ok) {
        toast.success("Profile updated successfully");
        await handleGetUserProfile(user.id, dispatch);
        setIsEditing(false);
        setIsUpdating(false);
      } else {
        toast.error(data?.message || "Update failed");
        setIsUpdating(false);
      }
    } catch (error) {
      toast.error(error.message || "Update failed");
      setIsUpdating(false);
    }
  };

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          {isEditing ? (
            <EditProfileForm
              user={userData}
              onSubmit={handleFormSubmit}
              onCancel={() => setIsEditing(false)}
              isSubmitting={isSubmitting}
            />
          ) : (
            <UserComponent
              user={userData}
              userDetails={userDetailsArray}
              onEdit={handleEdit}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default EditManagerProfile;
